import { Box } from "@mui/material";
import React from "react";
import { PageTitle } from "../components-new/common";
import IAComments from "./ImpactAnalysis/IAComments";
import { useLocation } from "react-router-dom";
import { HelpIconButton } from "../components-new/help/help-modal";

const Analytics = () => {
  const location = useLocation();
  const path = location.pathname;
  return (
    <Box sx={{ mt: 2, pb: 4 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <PageTitle title="Impact Analysis" />
        <HelpIconButton path={"/analytics"} />
      </Box>
      <IAComments />
    </Box>
  );
};

export default Analytics;
